import { SwapDepositToken } from '@kwenta/sdk/types'
import { FC, memo, useMemo } from 'react'
import styled from 'styled-components'

import DAIIcon from 'assets/png/tokens/DAI.png'
import SUSDWhiteIcon from 'assets/png/tokens/sUSD-White.png'
import USDCIcon from 'assets/png/tokens/USDC.png'
import BigToggle from 'components/BigToggle'
import SmallToggle from 'components/SmallToggle'
import { formatV3AssetKey } from 'utils/futures'
import { SYNTH_ICONS } from 'utils/icons'

import NumericInput from './NumericInput'

export const AssetSelector = memo(
	({
		small = true,
		assets,
		selectedAsset,
		onSelectAsset,
	}: {
		small: boolean
		assets: string[]
		selectedAsset: string
		onSelectAsset: (asset: string) => any
	}) => {
		const swapTokenIconMap = useMemo(
			() => ({
				[SwapDepositToken.DAI]: DAIIcon,
				[SwapDepositToken.USDC]: USDCIcon,
				[SwapDepositToken.SUSD]: SUSDWhiteIcon,
				...SYNTH_ICONS,
			}),
			[]
		)

		return (
			<div>
				{small ? (
					<SmallToggle
						value={selectedAsset}
						options={assets}
						onOptionClick={onSelectAsset}
						iconMap={swapTokenIconMap}
						labelFormatter={formatV3AssetKey}
					/>
				) : (
					<BigToggle
						options={assets}
						value={selectedAsset}
						onOptionClick={onSelectAsset}
						iconMap={swapTokenIconMap}
						labelFormatter={formatV3AssetKey}
					/>
				)}
			</div>
		)
	}
)

type DepositInputProps = {
	value: string
	small?: boolean
	selectedAsset: string
	assets?: string[]
	onSelectAsset: (asset: string) => void
	setValue(value: string): void
}

const InputWithAssetSelector: FC<DepositInputProps> = memo(
	({ small = true, value, selectedAsset, assets, onSelectAsset, setValue }) => {
		return (
			<DepositInputContainer>
				<DepositInputMain placeholder="0.00" value={value} onChange={(_, v) => setValue(v)} />
				{assets && (
					<AssetSelector
						small={small}
						assets={assets}
						selectedAsset={selectedAsset}
						onSelectAsset={onSelectAsset}
					/>
				)}
			</DepositInputContainer>
		)
	}
)

export default InputWithAssetSelector

export const DepositInputMain = styled(NumericInput)`
	border: 0;
	padding: 0;
	height: 23px;
	width: 100%;
	background: transparent;
	box-shadow: none;

	input {
		font-size: 30px;
		letter-spacing: -1px;
		height: 30px;
	}
`

export const DepositInputContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px;
	border: ${(props) => props.theme.colors.selectedTheme.newTheme.border.style};
	border-radius: 8px;

	input {
		font-size: 19px;
		font-family: ${(props) => props.theme.fonts.mono};
		color: ${(props) => props.theme.colors.selectedTheme.text.value};
		border: none;
		background-color: transparent;

		&:focus {
			outline: none;
		}
	}
`
